module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Angle-double-up-ae35717a8e1afd0002fb15c8bffa8355.svg";